import { jsx as _jsx } from "react/jsx-runtime";
import { MapButton } from "../MapButton";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
export const FullScreenButton = (props) => {
    const { fullScreen, onChange, } = props;
    const handleClick = () => onChange(!fullScreen);
    return (_jsx(MapButton, { icon: fullScreen ? _jsx(FullscreenExitIcon, {}) : _jsx(FullscreenIcon, {}), title: "Fullscreen", onClick: handleClick }));
};
